var map = {
	"./codeInLogo.webp": 4796,
	"./contactMail.webp": 436,
	"./contactMailDark.svg": 9812,
	"./cpp.svg": 6234,
	"./cuda.svg": 1206,
	"./developerActivity.svg": 9504,
	"./docker.svg": 7539,
	"./googleAssistant.svg": 9650,
	"./googleAssistantLogo.webp": 4217,
	"./jsFramework.svg": 4406,
	"./knu.jpg": 4755,
	"./kt.jpg": 5874,
	"./kt.png": 3254,
	"./lge.png": 5167,
	"./manOnTable.svg": 3350,
	"./matlab.svg": 632,
	"./me_and_ashish_vaswani.jpeg": 8217,
	"./nextuLogo.webp": 3480,
	"./opencv.svg": 2300,
	"./programmer.svg": 2075,
	"./pwa.webp": 7571,
	"./pwaLogo.webp": 4300,
	"./pytorch.svg": 1008,
	"./rok.jpg": 7779,
	"./rok.png": 1515,
	"./saayaHealthLogo.webp": 3267,
	"./skill.svg": 1262,
	"./socialService.png": 4073,
	"./talksCardBack.svg": 7175,
	"./tensorflow.svg": 5104
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;